import React from "react";
import { useState, useEffect } from "react";
import AuthService from "../../services/auth.service";
import api from "../../services/api";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import Weights from "../../components/Weights";
import Tabs from "../UI/Tabs";
import DiseaseList from "../../components/DiseaseList";
import AdminTopBar from "./AdminTopBar";
import Vaccines from "../../components/Vaccines";
import CalfInfoTab from "../../components/calf/CalfInfoTab";
import { CALF_SECTIONS } from "../../components/calf/calfSections";
function AdminCalf() {
  const currentUser = AuthService.getCurrentUser();
  if (!currentUser.roles.includes("ROLE_ADMIN")) navigate("/");
  const [calf, setCalf] = useState({});
  const [user, setUser] = useState({});
  const [view, setView] = useState("veau");
  const [isLoading, setLoading] = useState(true);
  const [isDownloadLoading, setDownloadLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { from } = location.state || "weights";
  let { calfId } = useParams();



  const getCalf = () => {
    api
      .get("/calfs/" + calfId)
      .then((response) => {
        const data = response.data;
        setCalf(data);
        getUser(data.fk_user);
      })
      .catch((error) => {
        console.error("There was an error fetching a calf!", error);
      });
  };
  const getUser = (userId) => {
    api.get("/user/" + userId)
      .then((response) => {
        setUser(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error getting the users!", error);
      });
  };
  const handleDownload = () => {
    setDownloadLoading(true);
    api
      .get("/print/" + calfId, { responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `rapport_${calf.name || calfId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setDownloadLoading(false);
      })
      .catch((error) => {
        console.error("There was an error downloading the report!", error);
        setDownloadLoading(false);
      });
  };
  const infoSection = CALF_SECTIONS.find((section) => section.id === view);

  const refreshCalf = () => {
    setLoading(true);
    setCalf({});
    getCalf(calfId);
  };
  const changeView = (view) => {
    setView(view);
  };

  useEffect(() => {
    //Runs only on the first render

    getCalf();
  }, []);
  if (isLoading) {
    return <div></div>;
  }
  return (
    <div>
      <AdminTopBar></AdminTopBar>
      <div className="text-sm md:flex md:flex-col md:items-center">
        <div className="mb-3 ml-3 flex md:w-[1200px]">
          <div className="flex items-center justify-center rounded-lg bg-stone-200/60 px-3 py-1">
            <Link to={"/admin/"}>
              <span className="text-sm font-medium text-stone-500">
                Tous les utilisateurs
              </span>
            </Link>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mr-1 h-4 w-4 text-stone-300"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 4.5l7.5 7.5-7.5 7.5"
              />
            </svg>
            <Link to={"/admin/user/" + user.id}>
              <span className="text-sm font-medium text-stone-500">
                {user.username}
              </span>
            </Link>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mr-1 h-4 w-4 text-stone-300"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 4.5l7.5 7.5-7.5 7.5"
              />
            </svg>
            <span className="text-sm font-semibold text-stone-700">
              {calf.name}
            </span>
          </div>
        </div>
        <div className="px-3 md:w-[1200px] md:bg-white">
          <div className="rounded-lg bg-white p-1">
            <div className="mb-3 ml-2 mt-1 flex justify-between">
              <div>
                <span className="text-2xl font-bold">{calf?.name}</span>
              </div>
              <div className="hidden md:flex">
                <button
                  onClick={() => handleDownload()}
                  disabled={isDownloadLoading ? true : false}
                  className="flex rounded-md border border-amber-500 bg-amber-400 px-3 py-2 text-sm text-white shadow transition-all duration-100 hover:shadow-inner"
                >
                  <div
                    className={
                      "flex flex-row items-center justify-center " +
                      (isDownloadLoading ? "" : "hidden")
                    }
                  >
                    <svg
                      className="mr-1 h-4 w-4 animate-spin text-amber-600"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="text-amber-200"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    <span>Traitement...</span>
                  </div>
                  <div className={isDownloadLoading ? "hidden" : "flex"}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="mr-3 h-4 w-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                      />
                    </svg>
                    <span>Rapport</span>
                  </div>
                </button>
              </div>
            </div>

            <Tabs
              value={view}
              onChange={changeView}
              tabs={[
                ...CALF_SECTIONS.map((section) => ({
                  id: section.id,
                  label: section.label,
                })),
                { id: "weights", label: "Poids" },
                { id: "health", label: "Maladies" },
                { id: "vaccin", label: "Vaccins" },
              ]}
              className="self-start"
            />
          </div>

          <div className="mt-4 w-full">
            {infoSection ? (
              <CalfInfoTab
                section={infoSection}
                calf={calf}
                onSaved={refreshCalf}
              />
            ) : view === "weights" ? (
              <Weights calf={calf}></Weights>
            ) : view === "health" ? (
              <DiseaseList calfID={calfId}></DiseaseList>
            ) : view === "vaccin" ? (
              <Vaccines calfID={calfId}></Vaccines>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminCalf;
